import React , {Component} from 'react'
import { Table, Button } from 'antd'
import Axios from 'axios'
import keys from '../../../keys'



class ProductPieceList extends Component{

    state = {
        data : []
    }

   

    formatTableData = () => {
        
        const products = this.props.productList.filter((item) => {if(item){return true}} )

        return products.map(
            (pp) => {
                
                    return {
                        key : pp.id,
                        id : pp.item_code,
                        product_name : pp.product_title,
                        product_code : pp.product_code,
                        date_loaded : pp.date_loaded,
                        button_id : pp.id
                    }
                
               
            }
        )
    }


    buttonClicked = (id) => {
        console.log(id)
        this.props.buttonClicked(id)
    }


    columns_with_load = [
        {
            title:"Piece ID",
            dataIndex:"id",
            key:"id"
        },
        {
            title:"Product Name",
            dataIndex:"product_name",
            key:"product_name"
        }
        ,
        {
            title:"Code",
            dataIndex:"product_code",
            key:"product_name"
        }
       
        ,
        {
            title:"",
            dataIndex:"button_id",
            key:"load button",
            render : (id) => <Button 
                                id={id} 
                                onClick={() =>  this.buttonClicked(id)} 
                                type="primary"> Load 
                            </Button>
        }



    ]



    columns_with_unload = [
        {
            title:"Piece ID",
            dataIndex:"id",
            key:"id"
        },
        {
            title:"Product Name",
            dataIndex:"product_name",
            key:"product_name"
        }
        ,
        {
            title:"Code",
            dataIndex:"product_code",
            key:"product_code"
        }
        ,
        {
            title:"Date Loaded",
            dataIndex:"date_loaded",
            key:"date_loaded",
            render : (date) => date.substr(0,10)
        }
        ,     
        {
           
            title:"",
            dataIndex:"button_id",
            key:"unload button",
            render : (id) => <Button id={id} onClick={(e) =>  this.buttonClicked(e.target.id)} type="danger"> Unload </Button>
            
        }
        
    
    ]



    render(){
        console.log(this.props)
        return(
           <Table 
            loading={this.props.loading} 
            title={()=>this.props.title} 
            size= "small" 
            columns={this.props.buttonType === "unload" ? this.columns_with_unload : this.columns_with_load} 
            dataSource={this.formatTableData()} />
        )
    }
}

export default ProductPieceList